import ReducerRegistry from '../base/redux/ReducerRegistry';
import { SET_RENDER_STATS } from './actionTypes';
export const STORE_NAME = 'features/perf-debug';
const DEFAULT_STATE = {
    renderStats: false
};
ReducerRegistry.register(STORE_NAME, (state = DEFAULT_STATE, action) => {
    switch (action.type) {
        case SET_RENDER_STATS:
            return {
                ...state,
                renderStats: action.open
            };
        default:
            return state;
    }
});
